const orderDetailsTestIDs = {
  screenBackButton: 'order-history-back-button',
  screenOrdersCount: 'order-history-orders-count',
  screenList: 'order-history-list',
  numberOfOrder: 'order-number',
  numberOfOrderLabel: 'order-number-label',
  numberOfOrderValue: 'order-number-value',
  orderSectionHeading: 'order-section-heading',
  clientDetailsSection: 'order-client-details-section',
  profileAvatar: 'order-profile-avatar',
  profileType: 'order-profile-type',
  profileName: 'order-profile-name',
  clientSince: 'order-profile-client-since',
  optaviaId: 'order-optavia-id',
  optaviaIdPrefix: 'order-optavia-id-prefix',
  optaviaIdLabel: 'order-optavia-id-label',
  optaviaIdValue: 'order-optavia-id-value',
  optaviaIdCopyButton: 'order-optavia-id-copy-button',
  optaviaIdCopyIcon: 'order-optavia-id-copy-icon',
  viewProfileButton: 'view-profile-button',
  viewProfileButtonLabel: 'view-profile-button-label',
  viewOrderHistoryButton: 'view-order-history-button',
  viewOrderHistoryButtonLabel: 'view-order-history-button-label',
  cv: 'order-cv',
  cvLabel: 'order-cv-label',
  cvValue: 'order-cv-value',
  qv: 'order-qv',
  qvLabel: 'order-qv-label',
  qvValue: 'order-qv-value',
  orderType: 'order-type',
  orderTypeLabel: 'order-type-label',
  orderTypeValue: 'order-type-value',
  orderDate: 'order-date',
  orderDateLabel: 'order-date-label',
  orderDateValue: 'order-date-value',
  orderRow: 'order-row',
  orderMetrics: 'order-metrics',
  subtotalConsumables: 'order-subtotal-consumables',
  subtotalConsumablesLabel: 'order-subtotal-consumables-label',
  subtotalConsumablesValue: 'order-subtotal-consumables-value',
  orderTotal: 'order-total',
  orderTotalLabel: 'order-total-label',
  orderTotalValue: 'order-total-value',
  orderStatus: 'order-status',
  orderStatusLabel: 'order-status-label',
  orderStatusValue: 'order-status-value',
  shipmentSectionHeading: 'shipment-section-heading',
  shipmentTrackingIdLabel: 'shipment-tracking-id-label',
  shipmentTrackingIdValue: 'shipment-tracking-id-value',
  trackingId: 'shipment-tracking-id',
  trackingIdLink: 'shipment-tracking-id-link',
  shipmentItemPrefix: 'shipment-item',
  shipmentItemImagePrefix: 'shipment-item-image',
  shipmentItemProductNamePrefix: 'shipment-item-product-name',
  shipmentItemQuantityLabelPrefix: 'shipment-item-quantity-label',
  shipmentItemQuantityPrefix: 'shipment-item-quantity',
  shipmentItemPricePrefix: 'shipment-item-price',
  shipmentItemQvCvPrefix: 'shipment-item-qv-cv',
  shipmentItemQvLabelPrefix: 'shipment-item-qv-label',
  shipmentItemCvLabelPrefix: 'shipment-item-cv-label',
  shipmentItemQvValuePrefix: 'shipment-item-qv-value',
  shipmentItemCvValuePrefix: 'shipment-item-cv-value',
  shipmentItemServingsLabelPrefix: 'shipment-item-servings-label',
  shipmentItemServingsPrefix: 'shipment-item-servings',
  addressesSectionHeading: 'addresses-section-heading',
  billingAddress: 'billing-address',
  billingAddressHeading: 'billing-address-heading',
  billingAddressLine1: 'billing-address-line-1',
  billingAddressLine2: 'billing-address-line-2',
  billingAddressCityState: 'billing-address-city-state',
  billingAddressPostalCode: 'billing-address-postal-code',
  billingAddressCountryCode: 'billing-address-country-code',
  billingAddressLinePrefix: 'billing-address-line',
  shippingAddress: 'shipping-address',
  shippingAddressHeading: 'shipping-address-heading',
  shippingAddressLine1: 'shipping-address-line-1',
  shippingAddressLine2: 'shipping-address-line-2',
  shippingAddressCityState: 'shipping-address-city-state',
  shippingAddressPostalCode: 'shipping-address-postal-code',
  shippingAddressCountryCode: 'shipping-address-country-code',
  shippingAddressLinePrefix: 'shipping-address-line',
  summarySectionHeading: 'summary-section-heading',
  summarySubtotal: 'summary-subtotal',
  summarySubtotalLabel: 'summary-subtotal-label',
  summarySubtotalValue: 'summary-subtotal-value',
  summaryShipping: 'summary-shipping',
  summaryShippingLabel: 'summary-shipping-label',
  summaryShippingValue: 'summary-shipping-value',
  summaryTax: 'summary-tax',
  summaryTaxLabel: 'summary-tax-label',
  summaryTaxValue: 'summary-tax-value',
  summaryTotal: 'summary-total',
  summaryTotalLabel: 'summary-total-label',
  summaryTotalValue: 'summary-total-value',
};

export default orderDetailsTestIDs;
